export default __webpack_public_path__ + "static/media/img4.68f11538.jpeg";